var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M11.327.26a1 1 0 011.433 1.39l-.087.09L6.5 7.35.327 1.74A1 1 0 011.575.18l.098.08L6.5 4.648 11.327.26z","fill":"currentColor","fill-rule":"nonzero"}})
}
var staticRenderFns = []

export { render, staticRenderFns }